import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { toDateTime } from '../../shared/functions/toDateTime';
import { Box, DialogContent} from '@material-ui/core';
import ReceivedDetailsItemDataGrid from './ReceivedDetailsItemDataGrid';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
  },
  toolBar :  {
      justifyContent :'space-between'
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function useInReceivingDetails() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = React.useCallback(() => {
    setOpen(false);
  },[]);

  const InReceivingDetails=React.useCallback(({ShippingId, Receiving})=>{

    return  <>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar className={classes.toolBar}>
                <Typography variant="h6" className={classes.title}>
                    { "CONTAINER CODE : " + Receiving.ContainerCode}
                </Typography>

                <Typography variant="h6">
                    {"CREE LE : "+ toDateTime(Receiving.CreateAt.seconds).toLocaleString()}
                </Typography>

                <Box>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>

                    <Button autoFocus color="inherit" onClick={handleClose}>
                        retour
                    </Button>
                </Box>

                </Toolbar>
            </AppBar>
            <DialogContent>
                <ReceivedDetailsItemDataGrid receiving={Receiving.ReceivedItems} receivingId={Receiving.id} closeDetail={handleClose} />
            </DialogContent>
            </Dialog>
     </>
  },[open, handleClose, classes])



  return {open , handleClose , handleClickOpen, InReceivingDetails }
}




